'use client';

import { createContext } from 'react';

/**
 * @group Types
 * 
 * @summary
 * <blockquote>Type definition for related data state that maps keys to arrays of related entities.</blockquote>
 * 
 * @example
 * ```typescript
 * const relatedData: RelatedDataState = {
 *   'users': userList,
 *   'roles': roleList,
 *   'permissions': permissionList
 * };
 * ```
 */
interface RelatedDataState {
  [key: string]: any[];
}

// Create a context that can be provided by parent components
export const RelatedDataContext = createContext<RelatedDataState | null>(null); 